import { Inject, Injectable, OnDestroy } from '@angular/core';
import { IS_BROWSER } from '@app/modules/core/tokens/app.tokens';
import { BehaviorSubject, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LcpDsDetectorService implements OnDestroy {

  protected observer: PerformanceObserver;
  
  protected _lcpElement$: BehaviorSubject<Element> = new BehaviorSubject(undefined);

  constructor(
    @Inject(IS_BROWSER) public isBrowser: boolean,
  ) {
    if (this.isBrowser) {
      if ('PerformanceObserver' in window) {
        this.observer = new PerformanceObserver(this.handleList.bind(this));
        this.observer.observe({ type: 'largest-contentful-paint', buffered: true });
      }
    }
  }

  ngOnDestroy(): void {
    this._lcpElement$?.unsubscribe();
    this.observer?.disconnect();
  }

  private get lcpElement$(): Observable<Element> {
    return this._lcpElement$.asObservable();
  }

  public isLcpElement$(src: string): Observable<boolean> {
    return this.lcpElement$.pipe(
      map(e => {
        return !!e?.['url'] && (e?.['url'] === src);
      })
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private handleList(list: any): void {
    if ('PerformanceObserver' in window) {
      const entries = (list as PerformanceObserverEntryList).getEntries();
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const lcpElement = entries[entries.length - 1] as any;
      if (lcpElement) {
        this.handleLcpElement(lcpElement);
      }
    }
  }

  private handleLcpElement(lcp: Element): void {
    if (lcp) {
      lcp?.['element']?.classList?.add?.('lcp-element');
      this._lcpElement$.next(lcp);
    }
  }
}
